import React from 'react';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import * as MYROUTES from './constants/routes';
import { SignInStatus, UserPane } from './userpane';
import Content, { ContentSetData, ContentStatus, getEmptyContentData } from './pages/content/content';
import Navigation from './navigation';
import GetLink from './pages/getlink/getlink';
import {Home} from './pages/home';
import Embed from './pages/embed/embed';
import Tasks, {TaskCreateStatus, TaskData, TaskDataMeta, TaskStatus, getEmptyTasksData} from './pages/tasks/tasks';
import FBWrapper, {MyUserType} from './firebase/fbwrapper';
import { TaskControlsAction } from './pages/tasks/viewtasks/viewtasks';
import { ContentSetActions } from './pages/content/contentsetmenu';
import Monitoring from './monitoring';

interface StateType{
	tasksList:string[];
	oneTasksData:TaskData;
	userContentList:string[];
	contentSetData:ContentSetData;
	isContentSetNew:boolean;
	isEdited:boolean;
	taskStatus:TaskStatus;
	taskCreateStatus:TaskCreateStatus;
	contentStatus:ContentStatus;
	user:MyUserType;
	signInStatus:SignInStatus;
}

export default class App extends React.Component{

	public state:StateType;
	private firebaseWrapper:FBWrapper;
	private taskClickedTitle:string='';//used when click on a diff task while waiting for taskdata reset 
	private contentClickedTitle:string='';
	private authListenerAdded:boolean=false;
	private monitoring:Monitoring;

	constructor(props:any){
		super(props);

		this.signInClick=this.signInClick.bind(this);
		this.signOutClick=this.signOutClick.bind(this);
		this.getTask=this.getTask.bind(this);
		this.taskControlsClick=this.taskControlsClick.bind(this);
		this.taskCreateClick=this.taskCreateClick.bind(this);
		this.resetTaskStatus=this.resetTaskStatus.bind(this);
		this.getContentSet=this.getContentSet.bind(this);
		this.newContentSet=this.newContentSet.bind(this);
		this.updateContentSet=this.updateContentSet.bind(this);
		this.contentSetMenuClick=this.contentSetMenuClick.bind(this);

		this.state={
			tasksList:[],
			userContentList:[],
			oneTasksData:getEmptyTasksData(),
			contentSetData:getEmptyContentData(),
			isContentSetNew:true,
			isEdited:false,
			taskStatus:TaskStatus.Default,
			taskCreateStatus:TaskCreateStatus.Default,
			contentStatus:ContentStatus.Default,
			user:{username:'', usermail:''},
			signInStatus:SignInStatus.No
		};

		this.firebaseWrapper=new FBWrapper();
		this.monitoring=new Monitoring();
	}

	componentDidMount(){
		this.addAuthListener();
	}

	////////////////////////////////////////////////////////////////////////////
	//login
  
	addAuthListener(){
		if(this.authListenerAdded===false){
			this.authListenerAdded=true;
			this.firebaseWrapper.addAuthListener((res:MyUserType)=>{
				if(res.username!==''){
					this.setState({user:res,signInStatus:SignInStatus.Yes});
					this.getTaskList();
					this.getContentList();
				}
			});
		}
	}

	signInClick(){
		if(this.state.signInStatus===SignInStatus.Yes)return;
		if(this.state.signInStatus===SignInStatus.Trying)return;
		this.setState({signInStatus:SignInStatus.Trying});
		this.firebaseWrapper.signIn((err:String)=>{
			if(err!=='')this.setState({signInStatus:SignInStatus.InFailed});
		});
	}

	signOutClick(){
		if(this.state.signInStatus!==SignInStatus.Yes)return;
		this.setState({signInStatus:SignInStatus.No, user:{username:'', usermail:''},tasksList:[],userContentList:[],oneTasksData:getEmptyTasksData(),contentSetData:getEmptyContentData(),isContentSetNew:true});
		this.firebaseWrapper.signOut((err:String)=>{
			if(err!=='')this.setState({signInStatus:SignInStatus.OutFailed});
		});
	}

	////////////////////////////////////////////////////////////////////////////
	//content

	getContentList(){
		this.setState({contentStatus:ContentStatus.GetList});
		this.firebaseWrapper.getContentList((contentStatus:ContentStatus,userContentList:string[])=>{
			this.setState({userContentList:userContentList,contentStatus:contentStatus});
		});
	}

	getContentSet(contentSet:string){
		//prevent repeated clicking
		if(contentSet===this.contentClickedTitle&&this.state.contentStatus===ContentStatus.GetSet)return;
		
		this.contentClickedTitle=contentSet;
		let newEmptySet=getEmptyContentData();
		newEmptySet.title=contentSet;
		this.setState({contentSetData:newEmptySet, contentStatus:ContentStatus.GetSet, isContentSetNew:false, isEdited:false});
		this.firebaseWrapper.getContentSet(contentSet,(contentStatus:ContentStatus, contentSetData:ContentSetData)=>{
			if(contentSetData.title===this.contentClickedTitle){
				this.contentClickedTitle='';
				this.setState({contentSetData:contentSetData, contentStatus:contentStatus});
			}
		});
	}

	newContentSet(){
		this.contentClickedTitle='';
		this.setState({contentSetData:getEmptyContentData(), isContentSetNew:true, contentStatus:ContentStatus.Default, isEdited:true});
	}

	updateContentSet(newContentSetData:ContentSetData){
		this.setState({contentSetData:newContentSetData, isEdited:true});
	}

	contentSetMenuClick(contentSetAction:ContentSetActions){
		if(contentSetAction===ContentSetActions.Delete)this.deleteUserContentSet();
		if(contentSetAction===ContentSetActions.Save)this.saveUserContentSet();
	}

	saveUserContentSet(){
		let isNew=this.state.isContentSetNew;
		this.setState({isContentSetNew:false,contentStatus:ContentStatus.SaveSet});
		this.firebaseWrapper.saveContentSet(this.state.contentSetData,this.state.userContentList,(contentStatus:ContentStatus, newUserContentList:string[], setID:number)=>{

			this.monitoring.saveContentSetOutcome(contentStatus,isNew,this.state.user.usermail,this.state.contentSetData,setID);

			let newContentSetData=this.state.contentSetData;
			newContentSetData.myID=setID;
			this.setState({userContentList:newUserContentList,contentStatus:contentStatus, isEdited:false, contentSetData:newContentSetData});

		});
	}

	deleteUserContentSet(){
		if(this.state.isContentSetNew){
			this.setState({contentSetData:getEmptyContentData()});
		}else{
			this.setState({contentStatus:ContentStatus.DeleteSet});
			this.firebaseWrapper.deleteContentSet(this.state.contentSetData.title,this.state.userContentList,(contentStatus:ContentStatus, newUserContentList:string[])=>{
				if(contentStatus===ContentStatus.DeleteSetError){
					this.setState({userContentList:newUserContentList,contentStatus:contentStatus});
				}else{
					this.setState({contentSetData:getEmptyContentData(), isContentSetNew:true, userContentList:newUserContentList,contentStatus:contentStatus});
				}
			});
		}
	}

	////////////////////////////////////////////////////////////////////////////
	//tasks

	getTaskList(){
		this.setState({taskStatus:TaskStatus.GetList});
		this.firebaseWrapper.getTaskList((taskStatus:TaskStatus,tasksList:string[])=>{
			this.setState({tasksList:tasksList,taskStatus:taskStatus});
		});
	}

	getTask(taskTitle:string){
		//prevent repeated clicking
		if(taskTitle===this.taskClickedTitle&&this.state.taskStatus===TaskStatus.GetTask)return;

		this.taskClickedTitle=taskTitle;
		this.setState({oneTasksData:getEmptyTasksData(),taskStatus:TaskStatus.GetTask});
		if(this.state.tasksList.indexOf(taskTitle)!==-1){
			this.firebaseWrapper.getTaskData(taskTitle,(taskStatus:TaskStatus,taskData:TaskData|null)=>{
				this.setState({oneTasksData:taskData,taskStatus:taskStatus});
			});
		}
	}

	taskControlsClick(taskControlsAction:TaskControlsAction, taskTitle:string){
		if(taskControlsAction===TaskControlsAction.Delete)this.deleteTask(taskTitle);
		if(taskControlsAction===TaskControlsAction.Reset)this.resetTaskData(taskTitle);
	}

	deleteTask(taskTitle:string){
		this.setState({oneTasksData:getEmptyTasksData(),taskStatus:TaskStatus.DeleteTask});
		this.firebaseWrapper.deleteTask(taskTitle,this.state.tasksList,(taskStatus:TaskStatus,tasksList:string[])=>{
			this.setState({tasksList:tasksList,taskStatus:taskStatus});
		});
	}
  
	resetTaskData(taskTitle:string){
		this.setState({oneTasksData:getEmptyTasksData(),taskStatus:TaskStatus.ResetTask});
		this.firebaseWrapper.resetTaskData(taskTitle,(taskStatus:TaskStatus)=>{
			if(taskTitle===this.taskClickedTitle){
				if(taskStatus===TaskStatus.ResetTaskFailed){
					this.setState({taskStatus:taskStatus});
				}else{
					this.getTask(taskTitle);
				}
			}
		});
	}

	taskCreateClick(taskCreateData:TaskDataMeta){
		this.setState({taskCreateStatus:TaskCreateStatus.Create});
		this.firebaseWrapper.createTask(taskCreateData,this.state.tasksList, (taskCreateStatus:TaskCreateStatus, newTaskList:string[])=>{

			this.monitoring.taskCreateClickOutcome(taskCreateStatus,taskCreateData);

			this.setState({tasksList:newTaskList, taskCreateStatus:taskCreateStatus});
		});
	}

	resetTaskStatus(){
		this.setState({taskCreateStatus:TaskCreateStatus.Default});
	}

	////////////////////////////////////////////////////////////////////////////

	render(){
		let isLoggedIn=this.state.user.username!=='';
		return (
			<div id="teachers-app">
				<UserPane 
					username={this.state.user.username}
					signIn={this.signInClick}
					signOut={this.signOutClick}
					signInStatus={this.state.signInStatus}
				/>
				<Router basename={'/teachers-section'}>
					<Navigation 
						isLoggedIn={isLoggedIn}
					/>
					<Routes>
		  				<Route path={MYROUTES.HOME} element={<Home />} />
						<Route path={MYROUTES.CONTENT} element={
							<Content 
								usermail={this.state.user.usermail}
								isContentSetNew={this.state.isContentSetNew}
								isEdited={this.state.isEdited}
								contentStatus={this.state.contentStatus}
								isLoggedIn={isLoggedIn}
								userContentList={this.state.userContentList}
								contentSetData={this.state.contentSetData}
								getContentSet={this.getContentSet}
								newContentSet={this.newContentSet}
								updateContentSet={this.updateContentSet}
								contentSetMenuClick={this.contentSetMenuClick}
							/>} />
						<Route path={MYROUTES.TASKS} element={
							<Tasks
								usermail={this.state.user.usermail}
								tasksList={this.state.tasksList}
								oneTasksData={this.state.oneTasksData}
								taskStatus={this.state.taskStatus}
								taskCreateStatus={this.state.taskCreateStatus}
								getTask={this.getTask}
								taskControlsClick={this.taskControlsClick}
								userContentList={this.state.userContentList}
								taskCreateClick={this.taskCreateClick}
								resetTaskStatus={this.resetTaskStatus}
							/>} />
						<Route path={MYROUTES.GETLINK} element={
							<GetLink 
								usermail={this.state.user.usermail}
								userContentList={this.state.userContentList}
							/>} />
						<Route path={MYROUTES.EMBED} element={
							<Embed 
								usermail={this.state.user.usermail}
								userContentList={this.state.userContentList}
							/>} />
					</Routes>
				</Router>
			</div>
		);
	}
}
